import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import caretDownIcon from 'src/assets/icons/caretDownIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiCaretDownIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.caretDownIcon}
      component={caretDownIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiCaretDownIcon.displayName = 'DlMuiCaretDownIcon';

const getStyles: GetStylesFunction = (options) => ({
  caretDownIcon: css`
    width: 16px;
    height: 16px;
    color: ${options?.theme?.palette.custom.coolGray['500']};
  `,
});
